import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function PeriodSelector({
  options = [],
  onChange,
  isLoading,
  period,
}) {
  const { t } = useTranslation(['form']);

  return (
    <Autocomplete
      value={period}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) => option.label}
      options={options ?? []}
      loading={isLoading}
      disabled={isLoading || options?.length === 0}
      disableClearable
      onChange={(_, value) => {
        onChange(value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label={t('payments.semi_monthly_summary.label', {
            ns: 'form',
          })}
          placeholder={t('payments.semi_monthly_summary.placeholder', {
            ns: 'form',
          })}
          fullWidth
          disabled={isLoading || options?.length === 0}
          slotProps={{
            inputLabel: { shrink: true },
            input: {
              ...params.InputProps,
              endAdornment: (
                <>
                  {isLoading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            },
          }}
        />
      )}
    />
  );
}
